var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-image",on:{"click":function($event){return _vm.showUserInfo($event)}}},[_c('img',{style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      cursor: 'pointer',
      objectFit: 'cover',
    }),attrs:{"src":_vm.url}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }